import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import React, { Component } from 'react';
import JssProvider from 'react-jss/lib/JssProvider';
import { getMaterialContext, STYLE_ELEMENT_ID } from './index';
import { ReactChildrenPropType } from '../commonPropTypes';

export class MaterialSSR extends Component {
  constructor(props) {
    super(props);

    this.materialContext = getMaterialContext();
  }

  componentDidMount() {
    // Remove stylesheet as suggested by:
    // http://cssinjs.org/server-side-rendering?v=v9.8.7
    const jssStyles = document.querySelector(`#${STYLE_ELEMENT_ID}`);
    if (jssStyles && jssStyles.parentNode) {
      jssStyles.parentNode.removeChild(jssStyles);
    }
  }

  render() {
    const { children } = this.props;

    return (
      <JssProvider
        registry={this.materialContext.sheetsRegistry}
        generateClassName={this.materialContext.generateClassName}
      >
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={this.materialContext.theme}>{children}</ThemeProvider>
        </StyledEngineProvider>
      </JssProvider>
    );
  }
}

MaterialSSR.propTypes = {
  children: ReactChildrenPropType
};

MaterialSSR.defaultProps = {
  children: null
};

// Add default export to maintain backward compatibility
export default MaterialSSR;
